import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Users, Award, TrendingUp, ArrowRight } from 'lucide-react';

const Services = () => {
  useEffect(() => {
    document.title = 'Hizmetlerimiz | akarma Eğitim ve Koçluk';
  }, []);

  const services = [
    {
      id: 'coaching',
      title: 'Koçluk Seansları',
      icon: Users,
      image: 'https://akarma.com.tr/upload/akarma/ser1.jpg',
      description: 'Koçluk seansları, derin kişisel sorunların birebir çözülmesi için NLP ile hızlı dönüşümsel terapi görüşmeleridir.',
      details: [
        'Hızlı dönüşümsel terapi ile derin kişisel sorunların çözümü',
        'NLP teknikleri ile bilinçaltı programlama',
        'Kuantum Sıçrama için Ayna Tekniği',
        'Birebir kişiye özel koçluk seansları',
        'Fobilerden kurtulma',
        'Ağrılar, korkular ve kaygılardan arınma',
        'Değersizlik ve suçluluk duygularının işlenmesi',
        'Panik atak tedavisi'
      ],
      link: '/iletisim'
    },
    {
      id: 'corporate',
      title: 'Kurumsal Eğitimler',
      icon: Award,
      image: 'https://akarma.com.tr/upload/akarma/ser2.jpg',
      description: 'Kurumsal firmaların yönetici ve çalışanları için hazırlanmış profesyonel eğitim programlarıdır.',
      details: [
        'Liderlik ve yönetim becerileri eğitimi',
        'Stres yönetimi ile mutlu bir yaşam',
        'Etkili iletişim ve farkındalık',
        'Duygusal zeka ve liderlik',
        'Şampiyonlar takımını yaratmak',
        'Çatışma yönetimi ve sorun çözme',
        'Sonuç odaklı satış teknikleri',
        'Sunum teknikleri ve beden dili'
      ],
      link: '/kurumsal-egitimler'
    },
    {
      id: 'motivation',
      title: 'Motivasyon Konuşmaları',
      icon: TrendingUp,
      image: 'https://akarma.com.tr/upload/akarma/ser3.jpg',
      description: 'Banu Gökcül kurumlara özel vizyon geliştiren, ilham veren, motive eden, duygusal çeviklik kazandıran motivasyon konuşmaları sunar.',
      details: [
        'Key Note Speaker - Motivasyon Konuşmacısı',
        'Vizyon geliştiren ve ilham veren konuşmalar',
        'Duygusal çeviklik kazandıran sunumlar',
        'Beyin programlama teknikleri',
        'Örgütsel konuşmacı organizasyonu',
        'Kuruma özel içerik hazırlama',
        'Uluslararası alanda etkinlik yönetimi',
        'CEO ve üst düzey yönetici konuşmaları'
      ],
      link: '/iletisim'
    }
  ];

  return (
    <div className="services pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 fade-in">Hizmetlerimiz</h1>
            <p className="text-xl md:text-2xl opacity-90">
              Kişisel ve kurumsal gelişim için profesyonel hizmetler sunuyoruz
            </p>
          </div>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="space-y-20">
            {services.map((service, index) => {
              const Icon = service.icon;
              const isEven = index % 2 === 0;
              
              return (
                <div key={service.id} id={service.id} className="scroll-mt-24">
                  <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                    !isEven ? 'lg:flex-row-reverse' : ''
                  }`}>
                    <div className={`${!isEven ? 'lg:order-2' : ''}`}>
                      <div className="flex items-center space-x-4 mb-6">
                        <div className="w-16 h-16 bg-gradient-to-br from-akarma-blue to-akarma-blue-700 rounded-xl flex items-center justify-center">
                          <Icon size={32} className="text-white" />
                        </div>
                        <h2 className="text-4xl font-bold">{service.title}</h2>
                      </div>
                      
                      <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                        {service.description}
                      </p>

                      <div className="space-y-3 mb-8">
                        {service.details.map((detail, idx) => (
                          <div key={idx} className="flex items-start space-x-3">
                            <div className="w-2 h-2 bg-akarma-blue rounded-full mt-2 flex-shrink-0"></div>
                            <p className="text-gray-700">{detail}</p>
                          </div>
                        ))}
                      </div>

                      <Link
                        to={service.link}
                        className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full font-semibold hover:shadow-lg transition-all duration-300"
                      >
                        Daha Fazla Bilgi
                        <ArrowRight size={20} className="ml-2" />
                      </Link>
                    </div>

                    <div className={`${!isEven ? 'lg:order-1' : ''}`}>
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-[500px] object-cover rounded-2xl shadow-2xl card-hover"
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-12 section-title">Neden Akarma?</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="text-5xl font-bold text-akarma-blue mb-4">20+</div>
                <h3 className="text-xl font-bold mb-2">Yıllık Deneyim</h3>
                <p className="text-gray-600">Örgütsel davranış ve koçluk alanında 20 yılı aşkın deneyim</p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="text-5xl font-bold text-purple-600 mb-4">100%</div>
                <h3 className="text-xl font-bold mb-2">Müşteri Memnuniyeti</h3>
                <p className="text-gray-600">Garanti vererek çözüm sağlayan kanlı etkinliğimiz</p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="text-5xl font-bold text-akarma-blue mb-4">500+</div>
                <h3 className="text-xl font-bold mb-2">Kurumsal Müşteri</h3>
                <p className="text-gray-600">Türkiye'nin önde gelen kurumları ile çalışma deneyimi</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="bg-gradient-to-r from-akarma-blue to-akarma-blue-700 rounded-3xl p-12 md:p-16 text-center text-white">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">Hizmetlerimiz Hakkında Daha Fazla Bilgi Almak İster misiniz?</h2>
            <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
              Size en uygun hizmeti belirlemek ve detaylı bilgi almak için bizimle iletişime geçin.
            </p>
            <Link
              to="/iletisim"
              className="inline-flex items-center px-8 py-4 bg-white text-akarma-blue rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 text-lg"
            >
              İletişime Geçin
              <ArrowRight size={24} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;